import { parse } from 'cookie';

export function getRzCookieValue(documentCookie: string): string {
	const { Rz } = parse(documentCookie);

	if (typeof Rz === 'undefined') {
		return '';
	}

	return Rz;
}

export function getNativeRzCookie(): string {
	return getRzCookieValue(document.cookie);
}
